import type { HistoricalEvent } from '@creanizer/types'

interface ExtendedHistoricalEvent extends HistoricalEvent {
  description?: string
  consequences?: string[]
}

interface WorldTimelineProps {
  events: ExtendedHistoricalEvent[]
}

export function WorldTimeline({ events }: WorldTimelineProps) {
  const getImpactColor = (impact: HistoricalEvent['impact']) => {
    switch (impact) {
      case 'critical':
        return 'bg-red-500'
      case 'major':
        return 'bg-orange-500'
      default:
        return 'bg-blue-500'
    }
  }
  
  const getCategoryLabel = (category: HistoricalEvent['category']) => {
    switch (category) {
      case 'political':
        return '政治'
      case 'cultural':
        return '文化'
      case 'technological':
        return '技術'
      case 'disaster':
        return '災害'
      case 'war':
        return '戦争'
      case 'discovery':
        return '発見'
      default:
        return 'その他'
    }
  }
  
  return (
    <div className="relative">
      <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />
      
      {events.map((event, index) => (
        <div key={index} className="relative flex items-start mb-8 ml-2">
          <div
            className={`
              absolute left-4 w-4 h-4 rounded-full -translate-x-1/2
              ${getImpactColor(event.impact)}
              ring-4 ring-background
            `}
          />
          
          <div className="ml-10 flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="px-2 py-0.5 bg-muted text-muted-foreground text-xs rounded">
                {getCategoryLabel(event.category)}
              </span>
              <span className="font-semibold text-sm">{event.year}</span>
              {event.impact === 'critical' && (
                <span className="px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full">
                  重要
                </span>
              )}
              {event.impact === 'major' && (
                <span className="px-2 py-0.5 bg-orange-100 text-orange-700 text-xs rounded-full">
                  主要
                </span>
              )}
            </div>
            <p className="font-medium text-sm mb-1">{event.event}</p>
            {event.description && (
              <p className="text-sm text-muted-foreground mb-2">{event.description}</p>
            )}
            {event.consequences && event.consequences.length > 0 && (
              <div className="mt-2">
                <p className="text-xs font-medium mb-1">影響・結果：</p>
                <ul className="list-disc list-inside text-xs text-muted-foreground space-y-0.5">
                  {event.consequences.map((consequence, cIndex) => (
                    <li key={cIndex}>{consequence}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}